module.exports = __webpack_public_path__ + "static/media/learning-2.1476de0f.svg";